import AccordionV2 from "@components/Accordion/AccordionV2";
import EventsAwardsAccordionHeader from "@events-awards/EventsAwardsAccordionHeader";

/**
 * Component to render award duration section for FAQ Page
 */
const AwardDurationSection = (): React.ReactElement => {
  return (
    <div
      className="bg-gray-150 font-public-sans"
      data-testid="award-duration-section-component"
    >
      <AccordionV2
        testId="award-duration"
        className="border-none py-2"
        headerChildren={
          <EventsAwardsAccordionHeader
            title="1. How long has the Award been established?"
            className="px-4"
          />
        }
        arrowClassName="h-auto w-auto -rotate-90 mr-6 border-none"
        isArrowRight
      >
        <div className="mx-4 px-6 py-6 pb-0">
          <p>
            The Emerging Enterprise Award was inaugurated in 2008, and the
            Emerging Enterprise Sustainability Award was inaugurated in 2023.
          </p>
        </div>
      </AccordionV2>
    </div>
  );
};

export default AwardDurationSection;
